import { useParams } from 'react-router-dom';

import { useContactsGroupContactsQuery } from '@dashboard/generated/wp/platform';
import { useCurrentPage } from '@dashboard/hooks/route/useCurrentPage';

export default function useCurrentContactsGroupContacts() {
  const id = useParams<{ id: string }>().id!;
  const page = useCurrentPage();
  return useContactsGroupContactsQuery({
    fetchPolicy: 'network-only',
    variables: { page, contactsGroupId: id },
  });
}
